import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Box,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import CloseIcon from "@mui/icons-material/Close";

type Props = {
  open: boolean;
  onClose: () => void;
  invoiceUrls: string[];
};

const isPdf = (url: string) => url.toLowerCase().endsWith(".pdf");

const InvoicePreviewModal: React.FC<Props> = ({
  open,
  onClose,
  invoiceUrls,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        Invoices
        <IconButton size="small" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={3}>
          {invoiceUrls.map((url, index) => {
            const isPdf = url.toLowerCase().endsWith(".pdf");

            return (
              <Grid item xs={12} sm={6} key={url}>
                <Box
                  sx={{
                    height: "100%",
                    border: "1px solid #E5E7EB",
                    borderRadius: 2,
                    p: 3,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    backgroundColor: "#FAFAFA",
                  }}
                >
                  <Box
                    sx={{
                      height: 160,
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      mb: 2,
                      backgroundColor: "#FFFFFF",
                      borderRadius: 1,
                      border: "1px solid #E5E7EB",
                    }}
                  >
                    {isPdf ? (
                      <PictureAsPdfIcon color="error" sx={{ fontSize: 64 }} />
                    ) : (
                      <Box
                        component="img"
                        src={url}
                        alt={`Invoice ${index + 1}`}
                        sx={{
                          maxHeight: "100%",
                          maxWidth: "100%",
                          objectFit: "contain",
                        }}
                      />
                    )}
                  </Box>

                  <Typography fontSize={16} fontWeight={600} mb={2}>
                    Invoice {index + 1}
                  </Typography>

                  <Button
                    variant="outlined"
                    size="medium"
                    sx={{ mt: "auto", width: 120 }}
                    onClick={() => window.open(url, "_blank")}
                  >
                    View
                  </Button>
                </Box>
              </Grid>
            );
          })}
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

export default InvoicePreviewModal;
